import { useState } from 'react'
import { fmtMoney, formatNZDateTime, formatNZTime, getItemName, getItemPrice, getItemQty, getItemsSummary } from '../lib/reportUtils'

export default function TransactionCard({ sale, compact = false, showDate = true }) {
  const [expanded, setExpanded] = useState(false)
  const items = Array.isArray(sale?.items) ? sale.items : []

  return (
    <div onClick={() => setExpanded(v => !v)} style={{ background: '#fff', border: '1.5px solid #e5e7eb', borderRadius: 10, padding: compact ? '10px 12px' : '12px 14px', marginBottom: 8, cursor: 'pointer' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#1a3a2a' }}>{sale?.customer_name || 'Walk-in'}</div>
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
            {sale?.payment_method || 'Unknown'} · {showDate ? formatNZDateTime(sale?.created_at) : formatNZTime(sale?.created_at)}
          </div>
          {!expanded && items.length > 0 && (
            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>
              {getItemsSummary(items)}
            </div>
          )}
        </div>
        <div style={{ fontWeight: 700, color: '#1a6b3c', fontSize: 15, whiteSpace: 'nowrap' }}>{fmtMoney(sale?.total_amount)}</div>
      </div>

      {expanded && (
        <div style={{ borderTop: '1px solid #e5e7eb', marginTop: 12, paddingTop: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6b7280', marginBottom: 8 }}>
            <span>Payment method</span>
            <strong style={{ color: '#1a3a2a' }}>{sale?.payment_method || 'Unknown'}</strong>
          </div>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Items</div>
          {items.length === 0 ? (
            <div style={{ fontSize: 12, color: '#9ca3af' }}>No item details recorded</div>
          ) : items.map((item, idx) => {
            const qty = getItemQty(item)
            const price = getItemPrice(item)
            return (
              <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#374151', marginBottom: 4, gap: 8 }}>
                <span>{qty}x {getItemName(item)}</span>
                <span>{fmtMoney(price * qty)}</span>
              </div>
            )
          })}
          {sale?.notes && (
            <div style={{ marginTop: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>Notes</div>
              <div style={{ fontSize: 12, color: '#6b7280', fontStyle: 'italic', marginTop: 2 }}>&quot;{sale.notes}&quot;</div>
            </div>
          )}
          {sale?.staff_email && (
            <div style={{ marginTop: 10, fontSize: 11, color: '#9ca3af' }}>Served by: {sale.staff_email}</div>
          )}
        </div>
      )}
    </div>
  )
}
